import {Routes} from "@angular/router";
import {AcConfigPage} from "./page/overview/config/ac-config.page";

export function AcSubRoutes(): Routes {

    /**
     *
     * path:
     * Prefix of the module will always be added to the path name
     *
     *      Example
     *      path: "addresses" => route path "ad/addresses" !
     * ------------------------------------------------------------------
     *
     * canActivate:
     * The authentication guard MsalGuard will be added automatically!
     * ------------------------------------------------------------------
     *
     * component:
     * Added components need to be from type "Page"!
     * ------------------------------------------------------------------
     *
     */
    const routes = [
        {path: 'ac/config', component: AcConfigPage},
    ];

    return routes;

}
